import { useTranslation } from "react-i18next";
import { AlertTriangle, CheckCircle2, RefreshCw } from "lucide-react";
import { startBackgroundSync, useBackgroundSync } from "../offline/backgroundSync";

// Header status of the background download of today's lessons: spinning
// while files are saved, a green tick once everything is on the phone, and
// a warning that retries when tapped.
export function SyncIndicator() {
  const { t } = useTranslation();
  const status = useBackgroundSync();
  if (status === "idle") return null;

  const view = {
    syncing: { label: t("syncStatusSyncing"), icon: RefreshCw, tone: "bg-accent-soft text-accent" },
    done: {
      label: t("syncStatusDone"),
      icon: CheckCircle2,
      tone: "bg-success-bg text-success-text",
    },
    error: {
      label: t("syncStatusError"),
      icon: AlertTriangle,
      tone: "bg-warning-bg text-warning-text",
    },
  }[status];
  const Icon = view.icon;

  return (
    <button
      type="button"
      onClick={() => void startBackgroundSync()}
      disabled={status === "syncing"}
      aria-label={view.label}
      title={view.label}
      className={`grid h-8 w-8 shrink-0 place-items-center rounded-full transition-colors disabled:cursor-default ${view.tone}`}
    >
      <Icon size={18} aria-hidden="true" className={status === "syncing" ? "animate-spin" : ""} />
      <span role="status" className="sr-only">
        {view.label}
      </span>
    </button>
  );
}
